export const readTokenColor = (name: `--${string}`, scope?: Element | null): string => {
  if (typeof document === "undefined") return ""
  return getComputedStyle(scope ?? document.documentElement)
    .getPropertyValue(name)
    .trim()
}
